export default {
  travelAssistants: false
}
